import { render, staticRenderFns } from "./SendingPolicyNotes.vue?vue&type=template&id=19df9a0f&scoped=true"
import script from "./SendingPolicyNotes.vue?vue&type=script&lang=js"
export * from "./SendingPolicyNotes.vue?vue&type=script&lang=js"
import style0 from "./SendingPolicyNotes.vue?vue&type=style&index=0&id=19df9a0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df9a0f",
  null
  
)

export default component.exports